import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function GuaranteeSection() {
  const ref = useScrollReveal<HTMLDivElement>();
  return <section className="bg-blanco-hueso py-[60px] px-5" data-id="element-88">
      <div className="max-w-[760px] mx-auto" data-id="element-89">
        <div ref={ref} className="opacity-0 translate-y-10 transition-all duration-700 ease-out bg-white rounded-card-lg p-10 max-w-[680px] mx-auto shadow-suave border-2 border-verde-menta flex gap-7 items-start flex-col md:flex-row" data-id="element-90">
          <div className="text-[3.5rem] flex-shrink-0" data-id="element-91">🛡️</div>
          <div data-id="element-92">
            <h3 className="font-display text-[1.4rem] text-verde-bosque mb-3" data-id="element-93">
              Garantía de "Resultado Real" de 7 Días
            </h3>
            <p className="text-gray-700 text-[0.95rem] leading-[1.8]" data-id="element-94">
              Si en 7 días de aplicar el protocolo no sientes menos inflamación,
              más energía estable y menos antojos de azúcar... simplemente
              escríbeme. Te devuelvo tus{' '}
              <strong data-id="element-95">$6.36 completos sin preguntas.</strong> Te quedas con el
              PDF. Seguimos siendo amigas. El riesgo es 100% mío, no tuyo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}